// extracted by mini-css-extract-plugin
module.exports = {"auto-profile-photo":"styles_auto-profile-photo__3pREm","profile-photo":"styles_profile-photo__3vh_G","separator":"styles_separator__2aN1B"};